module.exports = __webpack_public_path__ + "static/media/TN-Men-Pants.f09af79f.svg";